module.exports = __webpack_public_path__ + "img/page.b73e035a.png";